import React from 'react';

import { OuterFilterContextValue } from './types';

export const DEFAULT_OUTER_FILTER_CONTEXT: OuterFilterContextValue = {
  filter: {},
  setFilter: () => {},
  company: null,
  setCompany: () => {},
};

export const OuterFilterContext = React.createContext(DEFAULT_OUTER_FILTER_CONTEXT);
